/**
* IncomingQosEvent.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2018
*/
import { isValueAssigned } from "@microsoft/applicationinsights-core-js";
import { QosEvent } from "./QosEvent";
var IncomingQosEvent = /** @class */ (function () {
    function IncomingQosEvent() {
        this._qosEvent = new QosEvent();
    }
    IncomingQosEvent.prototype._setQosProperties = function (event, eventData) {
        this._qosEvent._setCommonProperties(event, eventData);
        if (isValueAssigned(eventData.callerIpAddress)) {
            event.baseData["callerIpAddress"] = eventData.callerIpAddress;
        }
        if (isValueAssigned(eventData.callerName)) {
            event.baseData["callerName"] = eventData.callerName;
        }
        if (isValueAssigned(eventData.requestSizeBytes)) {
            event.baseData["requestSizeBytes"] = eventData.requestSizeBytes;
        }
        if (isValueAssigned(eventData.operationVersion)) {
            event.baseData["operationVersion"] = eventData.operationVersion;
        }
    };
    return IncomingQosEvent;
}());
export { IncomingQosEvent };
//# sourceMappingURL=IncomingQosEvent.js.map